import { useState } from "react";
import { EsvPassage } from "@/components/EsvPassage";
import { ReaderMaps } from "@/components/ReaderMaps";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, BookOpenText } from "lucide-react";

const QUICK = ["John 1:1-14", "Psalm 23", "Romans 8", "Isaiah 53", "Matthew 5", "Philippians 4:4-9"];

export default function ReadBible() {
  const [q, setQ] = useState("");
  const [reference, setReference] = useState(null);

  const go = (ref) => {
    const v = (ref ?? q).trim();
    if (!v) return;
    setQ(v);
    setReference(v);
  };

  return (
    <div data-testid="read-bible-page" className="max-w-6xl mx-auto px-5 sm:px-8 pt-14 pb-10">
      <div className="text-center max-w-2xl mx-auto animate-rise">
        <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-gold mb-4">
          <BookOpenText className="w-4 h-4" /> World English Bible
        </span>
        <h1 className="font-serif text-4xl sm:text-5xl font-700 text-ink leading-tight">Read the Bible</h1>
        <p className="mt-4 text-ink/70 leading-relaxed">
          Enter any book, chapter, or verse to read the Scriptures — from a single verse to a whole chapter.
        </p>
      </div>

      <div className="mt-9 flex flex-col sm:flex-row gap-3">
        <div className="relative flex-1">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-ink/40" />
          <Input
            data-testid="read-bible-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") go(); }}
            placeholder="e.g. John 3:16, Psalm 23, Romans 8…"
            className="pl-11 h-14 rounded-full bg-card border-ink/15"
          />
        </div>
        <Button
          onClick={() => go()}
          data-testid="read-bible-submit"
          className="h-14 rounded-full bg-gold hover:bg-ink text-ink hover:text-parchment font-700 px-8"
        >
          Read
        </Button>
      </div>

      <div className="flex flex-wrap gap-2 mt-4 justify-center">
        {QUICK.map((r) => (
          <button
            key={r}
            data-testid="read-bible-quick"
            onClick={() => go(r)}
            className="px-4 py-1.5 rounded-full text-sm bg-card border border-border text-ink/70 hover:border-gold hover:text-ink transition-colors"
          >
            {r}
          </button>
        ))}
      </div>

      {reference && (
        <div className="mt-10 grid lg:grid-cols-[minmax(0,1fr)_340px] gap-6 items-start animate-rise">
          <div data-testid="read-bible-passage" className="bg-card rounded-3xl border border-border p-8 sm:p-10">
            <EsvPassage reference={reference} />
          </div>
          <ReaderMaps reference={reference} />
        </div>
      )}
    </div>
  );
}
